import { Link } from 'gatsby';
import React from 'react';

import { EditorialCard } from '../../helpers/list-page/interfaces/list-card.interface';
import ImageWrapper from '../image-wrapper/Image-wrapper';

interface CardEditorialItemProps {
  card: EditorialCard;
  cardIndex: number;
}

export const CardEditorialItem = ({
  card,
  cardIndex,
}: CardEditorialItemProps) => {
  return (
    <>
      <Link
        to={card?.slug}
        key={card?.id}
        className={`group relative flex aspect-0.75/1 animate-fadeIn cursor-pointer flex-col overflow-hidden rounded-xl opacity-0 focus:outline focus:outline-3 focus:outline-offset-3 focus:outline-text-light animation-delay-${cardIndex}`}
      >
        {card?.image && (
          <ImageWrapper
            gatsbyImageData={card?.image?.gatsbyImageData}
            file={card?.image?.file}
            svg={card?.image?.svg}
            alt={card?.image?.description ? card?.image?.description : ''}
            className="!absolute inset-0  aspect-0.75/1 transition-all"
            imgClassName="object-cover block w-full"
          />
        )}

        <div className="relative flex h-full flex-col justify-end bg-gradient-to-t from-transparency-overlay-solid px-6 py-4 transition-all duration-200 ease-in-out group-hover:bg-transparency-backdrop ">
          <h2 className="mb-2 font-title text-headingm text-brand-white transition-all duration-200 ease-in-out group-hover:text-brand-yellow-1">
            {card?.name}
          </h2>
        </div>
      </Link>
    </>
  );
};
